import React, { useState } from 'react';
import { CreditScorePanel, BorrowerData } from './components/CreditScorePanel';
const SCENARIOS: Record<string, {
  borrower: BorrowerData;
  coBorrower?: BorrowerData;
}> = {
  standard: {
    borrower: {
      name: 'John Doe',
      type: 'Primary',
      scores: [{
        bureau: 'Equifax',
        product: 'FICO',
        value: 750
      }, {
        bureau: 'Experian',
        product: 'FICO',
        value: 755
      }, {
        bureau: 'TransUnion',
        product: 'FICO',
        value: 760
      }, {
        bureau: 'Equifax',
        product: 'Vantage',
        value: 740
      }, {
        bureau: 'Experian',
        product: 'Vantage',
        value: 745
      }, {
        bureau: 'TransUnion',
        product: 'Vantage',
        value: 750
      }]
    },
    coBorrower: {
      name: 'Jane Doe',
      type: 'Co-Borrower',
      scores: [{
        bureau: 'Equifax',
        product: 'FICO',
        value: 720
      }, {
        bureau: 'Experian',
        product: 'FICO',
        value: 725
      }, {
        bureau: 'TransUnion',
        product: 'FICO',
        value: 730
      }, {
        bureau: 'Equifax',
        product: 'Vantage',
        value: 735
      }, {
        bureau: 'Experian',
        product: 'Vantage',
        value: 740
      }, {
        bureau: 'TransUnion',
        product: 'Vantage',
        value: 745
      }]
    }
  },
  fhaLow: {
    borrower: {
      name: 'John Doe',
      type: 'Primary',
      scores: [{
        bureau: 'Equifax',
        product: 'FICO',
        value: 750
      }, {
        bureau: 'Experian',
        product: 'FICO',
        value: 755
      }, {
        bureau: 'TransUnion',
        product: 'FICO',
        value: 760
      }, {
        bureau: 'Equifax',
        product: 'Vantage',
        value: 740
      }, {
        bureau: 'Experian',
        product: 'Vantage',
        value: 745
      }, {
        bureau: 'TransUnion',
        product: 'Vantage',
        value: 750
      }]
    },
    coBorrower: {
      name: 'Jane Doe',
      type: 'Co-Borrower',
      scores: [{
        bureau: 'Equifax',
        product: 'FICO',
        value: 670
      }, {
        bureau: 'Experian',
        product: 'FICO',
        value: 680
      }, {
        bureau: 'TransUnion',
        product: 'FICO',
        value: 690
      }, {
        bureau: 'Equifax',
        product: 'Vantage',
        value: 660
      }, {
        bureau: 'Experian',
        product: 'Vantage',
        value: 665
      }, {
        bureau: 'TransUnion',
        product: 'Vantage',
        value: 675
      }]
    }
  }
};
export function App() {
  const [activeScenario, setActiveScenario] = useState<'standard' | 'fhaLow'>('standard');
  const [loanType, setLoanType] = useState<'Standard' | 'FHA/Streamline'>('Standard');
  const handleScenarioChange = (scenario: 'standard' | 'fhaLow', type: 'Standard' | 'FHA/Streamline') => {
    setActiveScenario(scenario);
    setLoanType(type);
  };
  return <div className="min-h-screen w-full bg-gray-50 flex flex-col items-center justify-center p-6 gap-6" data-id="element-0">
      {/* Demo Controls */}
      <div className="flex flex-wrap gap-3" data-id="element-1">
        <button onClick={() => handleScenarioChange('standard', 'Standard')} className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${activeScenario === 'standard' ? 'bg-[#0082CA] text-white' : 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50'}`} data-id="element-2">
          Standard (Qualifying ≥ 740)
        </button>
        <button onClick={() => handleScenarioChange('fhaLow', 'FHA/Streamline')} className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${activeScenario === 'fhaLow' ? 'bg-[#0082CA] text-white' : 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50'}`} data-id="element-3">
          FHA/Streamline (Qualifying &lt; 740)
        </button>
      </div>

      {/* Credit Score Panel */}
      <div className="w-full max-w-2xl" data-id="element-4">
        <CreditScorePanel borrower={SCENARIOS[activeScenario].borrower} coBorrower={SCENARIOS[activeScenario].coBorrower} loanType={loanType} data-id="element-5" />
      </div>
    </div>;
}